/**
 *
 * Base
 *
 */

import 'fancybox';

( function( $ ) {
	'use strict';

	var htmlElement = document.getElementsByTagName( 'html' )[0];

	window.addEventListener( 'touchstart', function onFirstTouch() {
		htmlElement.classList.add( 'touch' );
		window.TOUCH_DEVICE = true;
		window.removeEventListener( 'touchstart', onFirstTouch, false );
	}, false );

	/**
	 *
	 * Detect OS class
	 *
	*/
	function detectOS() {
		const userAgent = navigator.userAgent;
		if ( -1 !== userAgent.indexOf( 'Macintosh' ) ) {
			return 'mac';
		} else if ( -1 !== userAgent.indexOf( 'Windows' ) ) {
			return 'windows';
		} else if ( -1 !== userAgent.indexOf( 'Linux' ) ) {
			return 'linux';
		} else {
			return 'unknown-os';
		}
	}

	/**
	 *
	 * Add OS class
	 *
	*/
	function addOSClass() {
		const os = detectOS();
		document.body.classList.add( os );
	}
	document.addEventListener( 'DOMContentLoaded', addOSClass );

	/**
	 *
	 * Header Scroll
	 *
	 */
	$( window ).scroll( function() {

		var scroll = $( window ).scrollTop();
		if( 100 <= scroll ) {
			$( 'html' ).addClass( 'is-scrolled' );
		}
		if( 99 >= scroll ) {
			$( 'html' ).removeClass( 'is-scrolled' );
		}

	} );


	/**
	 *
	 * Instantiate Fancybox
	 *
	 */
	$( '[data-fancybox]' ).fancybox( {
		focus: false,
		buttons: [ 'close' ],
		/** video aspect ratio **/
		onUpdate : function( instance, current ) {
			var width,
				height,
				ratio = 16 / 9,
				video = current.$content;

			if ( video ) {
				video.hide();

				width  = current.$slide.width();
				height = current.$slide.height() - 100;

				if ( height * ratio > width ) {
					height = width / ratio;
				} else {
					width = height * ratio;
				}

				video.css( {
					width  : width,
					height : height
				} ).show();

			}
		}
	} );
	$.fancybox.defaults.hash = false;

	/**
	 *
	 * Open .pdf files in new tab
	 *
	 */
	$( '[href$=".pdf"]' ).attr( 'target','_blank' );

	/*
	*
	* Get http referrer and set body class if from portal
	*
	*/
	const referrer = document.referrer;
	const body = document.querySelector( 'body' );

	if ( -1 < referrer.indexOf( 'mxperience.themxgroup.com' ) ) {
		body.classList.add( 'portal-referred' );
	}


	/*
	*
	* Remove Top Padding on Main Content
	* If first child is a hero
	*/
	var $hero = $( '.hero' ),
		$heroParent = $hero.parent(),
		$mainContent = $( '.main-content' );

	if( $heroParent.hasClass( 'main-content' ) ) {
		$mainContent.addClass( 'remove-top-pad' );
	}

} )( jQuery );
